export const MENU_LINK_DASHBOARD = '/';

export const MENU_LINK_CREATE = '/content';
